import { Component, Input, OnInit } from '@angular/core';
import { faArrowDown, faDownload, IconDefinition } from '@fortawesome/pro-solid-svg-icons';
import { Store } from '@ngxs/store';
import _ from 'lodash';
import { GetAttachment, GetAttachments } from 'src/app/store/samwin/samwin-mail-list/samwin-message-list.actions';
import { Attachment } from 'src/generated/swagger';

@Component({
   selector: 'samweb-attachment-bar',
   templateUrl: './attachment-bar.component.html',
   styleUrls: ['./attachment-bar.component.scss'],
})
export class AttachmentBarComponent implements OnInit {
   @Input()
   public attachments: Attachment[];

   @Input()
   public attachmentDisplayLimit = 8;

   @Input()
   public messageId: string;

   public downloadIcon: IconDefinition = faDownload;

   public downloadItemIcon: IconDefinition = faArrowDown;

   public displayOtherAttachments = false;

   constructor(public store: Store) {}

   ngOnInit() {}

   openAttachmentDialog() {
      this.displayOtherAttachments = true;
   }

   closeAttachmentDialog() {
      this.displayOtherAttachments = false;
   }

   downloadAttachment(attachment: Attachment) {
      if (!_.isNil(attachment?.uId)) {
         this.store.dispatch(new GetAttachment(attachment, this.messageId));
      }
   }

   downloadAttachments() {
      this.store.dispatch(new GetAttachments(this.attachments, this.messageId));
   }
}
